import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { uploadAndRetrieveFiles } from "../functions/firebase/storage";
import { getDownloadURL } from "firebase/storage";
import { v4 } from "uuid";
import { collection, deleteDoc, doc, getDocs, query, setDoc, updateDoc } from "firebase/firestore";
import { db } from "../databases/firebase";
import { async } from "@firebase/util";
import { addNewDocumentToFS } from "../functions/firebase/firestore";

const initialState = { allUpcomingChallenges: {}, allActiveChallenges: {}, completedChallenges: {}, isLoading: false, message: "" };

export const addChallengeAnnouncementThunk = createAsyncThunk(
   "challenges/thunk/announcement/add",
   async (payload, { dispatch, rejectWithValue }) => {
      try {
         const { imageLink } = payload.coverImageDetails;
         const _imageID = `_challengeID${payload._challengeID}-_coverImageID${v4()}`;

         const addCoverImageToStorage = await uploadAndRetrieveFiles(_imageID, imageLink, 'challenge');

         const downloadURL = await getDownloadURL(addCoverImageToStorage.ref);

         return { ...payload, coverImageDetails: { ...payload.coverImageDetails, imageLink: downloadURL } };
      } catch (err) {
         console.error({ origin: 'addUpcomingChallengeThunk', err, errMessage: err.message, errCode: err.code, rejectWithValue: rejectWithValue('REJECT WITH VALUE ERROR!!!') });
         rejectWithValue('ERROR!!! REJECT WITH VALUE FROM ADDUPCOMINGCHALLENGETHUNK!!!');
      }
   }
)

export const addUpcomingChallengeToFSandReduxThunk = createAsyncThunk(
   "challenges/thunk/FirestoreAndRedux/add",
   async (payload, { dispatch, rejectWithValue }) => {
      const { imageLink, source } = payload.coverImageDetails;
      const { _challengeID, challengeVideos } = payload;
      const _imageID = `_challengeID${_challengeID}-_coverImageID${v4()}`;

      try {
         if (source === "computer") {
            const addCoverImageToStorage = await uploadAndRetrieveFiles(_imageID, imageLink, 'challenge');
            const downloadURL = await getDownloadURL(addCoverImageToStorage.ref);

            payload = {
               ...payload,
               coverImageDetails: {
                  ...payload.coverImageDetails,
                  imageLink: downloadURL,
                  _coverImageID: _imageID
               }
            };

         } else {
            payload = {
               ...payload,
               coverImageDetails: {
                  ...payload.coverImageDetails,
                  _coverImageID: _imageID
               }
            };
         }

         const addVideoToFB = await setDoc(doc(db, "internet-idol-faceoff", "Challenges", "challengeAnnouncements", _challengeID), { ...payload }); //*** IMPORTANT!!! *** Make sure your "payload" does NOT have any undefined values! Otherwise, you will get an invalid data error.

         return { ...payload };
      } catch (err) {
         console.error({ origin: "addUpcomingChallengeToFSandRedux", err, errCode: err.code, errMessage: err.message, rejectWithValue: rejectWithValue("rejectWithValue error thrown on addUpcomingChallengeToFSandRedux!!!!!") });
      }
   }
)

export const addActiveChallengeThunk = createAsyncThunk(
   "challenges/thunk/active/add",
   async (payload, { dispatch, rejectWithValue }) => {
      const { _challengeID, coverImageDetails: { source } } = payload;
      const _imageID = `_challengeID${payload._challengeID}-_coverImageID${v4()}`;
      try {
         if (source === "computer") {
            const { imageLink } = payload.coverImageDetails;
            const addCoverImageToStorage = await uploadAndRetrieveFiles(_imageID, imageLink, 'challenge');
            const downloadURL = await getDownloadURL(addCoverImageToStorage.ref);

            payload = {
               ...payload,
               coverImageDetails: {
                  ...payload.coverImageDetails,
                  _coverImageID: _imageID,
                  imageLink: downloadURL
               }
            };
         } else {
            payload = {
               ...payload,
               coverImageDetails: {
                  ...payload.coverImageDetails,
                  _coverImageID: _imageID
               }
            }
         }

         const addDocumentToFB = await setDoc(doc(db, "internet-idol-faceoff", "Challenges", "activeChallenges", _challengeID), { ...payload });

         return payload;
      } catch (err) {
         console.error({ origin: 'addUpcomingChallengeThunk', err, errMessage: err.message, errCode: err.code, rejectWithValue: rejectWithValue('REJECT WITH VALUE ERROR!!!') });
         rejectWithValue('ERROR!!! REJECT WITH VALUE FROM ADDUPCOMINGCHALLENGETHUNK!!!');
      }
   }
)

export const updateFSupcomingChallenges = createAsyncThunk(
   "challenges/updateFSupcomingChallenges",
   async (payload, { rejectWithValue }) => {
      const { _challengeID, ...updatedProperties } = payload;
      try {
         const upcomingChallengeRef = doc(db, "internet-idol-faceoff", "Challenges", "challengeAnnouncements", _challengeID);
         const updateUpcomingChallenge = await updateDoc(upcomingChallengeRef, { ...updatedProperties, _challengeID });

         return payload;
      } catch (error) {
         console.error({origin: "updateFSupcomingChallenges", error, errorCode: error.code, errorMessage: error.message, payload, rejectWithValue: rejectWithValue("rejectWithValue error inside update FS upcomingChallenges!!!")})
      }
   }
)

export const updateReduxWithFSactiveChallengesData = createAsyncThunk(
   "challenges/updateReduxWithFSactiveChallenges",
   async (payload, { dispatch, rejectWithValue }) => {
      const allActiveChallenges = {};
      try {
         const activeChallengesQuery = query(collection(db, "internet-idol-faceoff", "Challenges", "activeChallenges"));
         const activeChallengesSnapshot = await getDocs(activeChallengesQuery);
         activeChallengesSnapshot.forEach(val => allActiveChallenges[val.id] = { ...val.data() })

         return allActiveChallenges;
      } catch (error) {
         console.error({ error, errorCode: error.code, errorMessage: error.message, rejectWithValue: rejectWithValue(`Error trying to upload active challenge with ${JSON.stringify(payload)}`, payload) });
      }
   }
)

export const updateReduxWithFScompletedChallengesData = createAsyncThunk(
   "challenges/updateReduxWithFScompletedChallenges",
   async (payload, { dispatch, rejectWithValue }) => {
      const completedChallenges = {};
      try {
         const completedChallengesQuery = query(collection(db, "internet-idol-faceoff", "Challenges", "completedChallenges"));
         const completedChallengesSnapshot = await getDocs(completedChallengesQuery);
         completedChallengesSnapshot.forEach(val => completedChallenges[val.id] = { ...val.data() });

         return completedChallenges;
      } catch (error) {
         console.error({error, errorCode: error.code, errorValue: error.value, rejectWithValue: rejectWithValue("Inside updateReduxWithFScompletedChallengesData rejectWithValue error!!!")})
      }
   }
)

export const updateReduxWithFSupcomingChallengesData = createAsyncThunk(
   "challenges/updateReduxWithFSupcomingChallenges",
   async (payload, { dispatch, rejectWithValue }) => {
      const allUpcomingChallenges = {};
      try {
         const updatedChallengesQuery = query(collection(db, "internet-idol-faceoff", "Challenges", "challengeAnnouncements"));
         const updatedChallengesQuerySnapshot = await getDocs(updatedChallengesQuery);
         updatedChallengesQuerySnapshot.forEach(doc => allUpcomingChallenges[doc.id] = { ...doc.data() });

         return allUpcomingChallenges;
      } catch (error) {
         console.error({ origin: "updateReduxWithFSupcomingChallengesData", error, errorCode: error.code, errorMessage: error.message, rejectWithValue: rejectWithValue({ message: "rejectWithValueError!!!", payload }) });
      }
   }
)

export const FStransferChallenge = createAsyncThunk(
   'challenges/transfer',
   async(payload, { dispatch, rejectWithValue }) => {
      const { key, value, oldCollection, oldCollectionPathArray, newCollection, newCollectionPathArray } = payload;
      //oldCollectionPathArray and newCollectionPathArray should be the path to the new collection as an array: ['internet-idol-faceoff', 'Challenges', 'completedChallenges'].

      //oldCollection and newCollection refers to the collection keys inside initialValue.

      try {
         const addToNewCollection = setDoc(doc(db, ...newCollectionPathArray), { ...value }).then(() => {
            console.log(`Inside FS TransferChallenge: successfully added ${payload} to ${newCollectionPathArray}.`)
         }).catch(err => console.error({ err, errCode: err.code, errMessage: err.message, message: `something went wrong inside newCollectionPathArray. The payload is ${payload} and the newCollectionPathArray is ${newCollectionPathArray},` }));

         const removeFromOldCollection = await deleteDoc(doc(db, ...oldCollectionPathArray))
         console.log({ addToNewCollection, removeFromOldCollection });

         return payload;
      } catch (error) {
         console.error({ error, errorCode: error.code, errorMessage: error.message, message: "Something went wrong inside FStransferChallenge createAsyncThunk", rejectWithValue: rejectWithValue("Reject with value error inside FStransferChallenge!!!") })
      }
   }
)

export const FStransferChallengeFromUpcomingToActive = createAsyncThunk(
   "challenges/FStransferChallenge",
   async (payload, { dispatch, rejectWithValue }) => {
      const { key, value, oldType, newType } = payload;
      try {
         const addActiveChallengeToFS = await setDoc(doc(db, "internet-idol-faceoff", "Challenges", "activeChallenges", key), { ...value });

         // dispatch(transferChallenge({ ...payload }));

         const removeOldChallengeAnnouncement = await deleteDoc(doc(db, "internet-idol-faceoff", "Challenges", "challengeAnnouncements", key));

         return payload;
      } catch (error) {
         console.error({ error, errorCode: error.code, errorValue: error.value, rejectWithValue: rejectWithValue(`REJECT WITH VALUE ERROR: ${JSON.stringify(payload)}`, payload) });
      }
   }
)

const challengesSlice = createSlice({
   name: "challenges",
   initialState,
   reducers: {
      addNewUpcomingChallenge: (state, { payload }) => {

         return { ...state, allUpcomingChallenges: { ...state.allUpcomingChallenges, [payload._challengeID]: { ...payload } } };
      },

      updateChallenge: (state, { payload }) => {
         const { type, key, value } = payload;
         
         if (type === 'allUpcomingChallenges') {
            return { ...state, allUpcomingChallenges: { ...state.allUpcomingChallenges, [key]: { ...value } } };
         } else {
            return { ...state, allActiveChallenges: { ...state.allActiveChallenges, [key]: { ...value } } };
         }
      },

      removeUpcomingChallenge: (state, { payload }) => {
         const { [payload._challengeID]: _challengeID, ...rest } = state.allUpcomingChallenges;

         return { ...state, allUpcomingChallenges: { ...rest } };
      },

      removeActiveChallenge: (state, { payload }) => {
         const { [payload._challengeID]: _challengeID, ...rest } = state.allActiveChallenges;

         return { ...state, allActiveChallenges: { ...rest } };
      },

      addActiveChallenge: (state, { payload }) => {
         const { addChallengeAnnouncement } = payload.upcomingChallengeProperties;

         if (addChallengeAnnouncement) {
            const {
               [payload._challengeID]: upcomingChallengeConverted,
               ...remainingUpcomingChallenges
            } = allUpcomingChallenges;

            return { ...state, allUpcomingChallenges: { ...remainingUpcomingChallenges }, allActiveChallenges: { ...state.allActiveChallenges, [upcomingChallengeConverted._challengeID]: { ...upcomingChallengeConverted } } }
         } else {
            return { ...state, allActiveChallenges: { ...state.allActiveChallenges, [payload._challengeID]: { ...payload } } }
         }
      },


      transferChallenge: (state, { payload }) => {
         const { key, value, oldType, newType } = payload;
         state[newType][key] = value; //add new challenge object to new category/type.
         delete state[oldType][key] //remove challenge object from old category.

         return state;
      }
   },
   extraReducers: {
      [addChallengeAnnouncementThunk.pending]: state => {
         state.isLoading = true;
         state.message = "Please wait while we load the new challenge ANNOUNCEMENT...";
      },
      [addChallengeAnnouncementThunk.fulfilled]: (state, { payload }) => {
         state.isLoading = false;
         state.message = "";
         state.allUpcomingChallenges = { ...state.allUpcomingChallenges, [payload._challengeID]: { ...payload } };
      },
      [addChallengeAnnouncementThunk.rejected]: (state, { rejectWithValue, payload, error }) => {
         if (error) {
            console.error({ from: [addChallengeAnnouncementThunk.rejected], error, errorCode: error.code, errorValue: error.value, payload, rejectWithValue: rejectWithValue('REJECT WITH VALUE ERROR IN addChallengeAnnouncementThunk.rejected.') });
         } else {
            console.error({ from: [addChallengeAnnouncementThunk.rejected], message: 'ERROR UPLOADING ANNOUNCEMENT!!!', rejectWithValue: rejectWithValue('REJECT WITH VALUE ERROR IN addChallengeAnnouncementThunk.rejected'), payload });
         }
      },
      [addUpcomingChallengeToFSandReduxThunk.pending]: (state, { payload }) => {
         state.isLoading = true;
         state.message = `Please wait while we upload ${JSON.stringify(payload) || payload} to Firebase and/or storage...`;
         console.log({ isLoading: true, message: state.message });
      },
      [addUpcomingChallengeToFSandReduxThunk.fulfilled]: (state, { payload }) => {

         state.isLoading = false;
         state.message = "";

         state.allUpcomingChallenges = { ...state.allUpcomingChallenges, [payload._challengeID]: { ...payload } };
      },
      [addUpcomingChallengeToFSandReduxThunk.rejected]: (state, { payload, error, rejectWithValue }) => {
         state.isLoading = false;
         state.message = "";
         if (error || rejectWithValue) {
            console.error({ origin: "addUpcomingChallengeToFSandReduxThunk.rejected", error, errorCode: error.code, errorMessage: error.message, rejectWithValue: rejectWithValue("rejectWithValue error inside addUpcomingChallengeToFSandReduxThunk.rejected!!!") });
         } else {
            console.error({ origin: "addUpcomingChallengeToFSandReduxThunk.rejected", message: "Something went wrong trying to add upcoming challenge!!!" });
         }
      },
      [FStransferChallenge.pending]: state => {
         state.isLoading = true;
         state.message = "Please be patient while we transfer your challenge from one collection to another."
         console.log({ message: `*** IMPORTANT MESSAGE FROM FStransferChallenge!!! ***\n... ${state.message}`, loading: state.isLoading });
      },
      [FStransferChallenge.fulfilled]: (state, { payload }) => {
         state.isLoading = false;
         state.message = "";
         let { oldProperty, newProperty, key, value } = payload;
         state[newProperty][key] = value;
         delete state[oldProperty][key];
      },
      [FStransferChallenge.rejected]: (state, { error, rejectWithValue }) => {
         state.isLoading = false;
         state.message = "";
         if (error || rejectWithValue) {
            console.error({ error, errorCode: error.code, errorMessage: error.message });
            console.error({rejectWithValue: rejectWithValue})
         } else {
            console.error("Something went wrong while trying to tranfer the challenge from one collection to the next!!!")
         }
      },
      [FStransferChallengeFromUpcomingToActive.pending]: state => {
         state.isLoading = true;
         state.message = "Please wait while we convert challenge from upcoming to active...";

         console.log({ isLoading: state.isLoading, message: state.message });
      },
      [FStransferChallengeFromUpcomingToActive.fulfilled]: (state, { payload }) => {
         state.isLoading = false;
         state.message = "";
         
         const { key, value, oldType, newType } = payload;
         state[newType][key] = value;
         delete state[oldType][key];
      },
      [FStransferChallengeFromUpcomingToActive.rejected]: (state, { payload, error, rejectWithValue }) => {
         state.isLoading = false;
         state.message = "";

         if (rejectWithValue || error) {
            console.error({ error, errorCode: error.code, errorMessage: error.message, rejectWithValue: rejectWithValue("Reject with value error while transferring challenge from upcoming to active.", payload) });
         } else {
            console.error({ message: "Error while transerring challenge from upcoming to active.", payload });
         }
      },
      [updateReduxWithFSactiveChallengesData.pending]: state => {
         state.isLoading = true;
         state.message = "Please be patient as we upload active challenges from Firestore to Redux...";
         console.log({ isLoading: state.isLoading, message: state.message });
      },
      [updateReduxWithFSactiveChallengesData.fulfilled]: (state, { payload }) => {
         state.isLoading = false;
         state.message = "";
         state.allActiveChallenges = { ...state.allActiveChallenges, ...payload };
      },
      [updateReduxWithFSactiveChallengesData.rejected]: (state, { payload, rejectWithValue, error }) => {
         state.isLoading = false;
         state.message = "";

         if (error || rejectWithValue) {
            console.error({ error, errorCode: error.code, errorMessage: error.message, rejectWithValue: rejectWithValue("REJECT WITH VALUE ERROR WHILE ADDING ACTIVE CHALLENGES!!!", payload) });
         } else {
            console.error({ message: "Error trying to upload active challenges inside challengesSlice.js!!!" });
         }
      },
      [updateReduxWithFScompletedChallengesData.pending]: state => {
         state.isLoading = true;
         state.message = "Please wait while we load completed challenges to Redux..."
         console.log({ isLoading: state.isLoading, message: state.message });
      },
      [updateReduxWithFScompletedChallengesData.fulfilled]: (state, { payload }) => {
         state.isLoading = false;
         state.message = "";
         state.completedChallenges = { ...state.completedChallenges, ...payload };
      },
      [updateReduxWithFSupcomingChallengesData.pending]: state => {
         state.isLoading = true;
         state.message = "Please be patient as we upload upcoming challenges from Firestore to Redux...";
         console.log({ isLoading: state.isLoading, message: state.message });
      },
      [updateReduxWithFSupcomingChallengesData.fulfilled]: (state, { payload }) => {
         state.isLoading = false;
         state.message = "";
         console.log({ isLoading: state.isLoading, message: `updateReduxWithFSupcomingChallengesData is successful. payload is ${JSON.stringify(payload)}.` });
         state.allUpcomingChallenges = { ...state.allUpcomingChallenges, ...payload };
      },
      [updateReduxWithFSupcomingChallengesData.rejected]: (state, { error, rejectWithValue, payload }) => {
         state.isLoading = false;
         state.message = "";
         if (error || rejectWithValue) {
            console.error({origin: "updateReduxWithFSupcomingChallengesData.rejected", error, errorCode: error.code, errorMessage: error.message, payload, rejectWithValue: ("Inside updateReduxWithFSUpcomingChallengesData: rejectWithValue error!!!")})
         } else {
            console.error({ message: "Something went wrong transferring data from upcomingChallenges in Firestore to Redux!!!", payload });
         }
      },
      [addActiveChallengeThunk.pending]: state => {
         state.isLoading = true;
         state.message = 'please wait while we upload the cover image to the ACTIVE challenge.'
         console.log({ isLoading: state.isLoading, message: state.message });
      },
      [addActiveChallengeThunk.fulfilled]: (state, { payload }) => {
         state.isLoading = false;
         state.message = "";

         state.allActiveChallenges = { ...state.allActiveChallenges, [payload._challengeID]: { ...payload } };
      },
      [addActiveChallengeThunk.rejected]: (state, { payload, rejectWithValue, error }) => {         
         if (error || rejectWithValue) {
            console.error({ error, errorCode: error.code, errorMessage: error.message, rejectWithValue: rejectWithValue(`rejectWithValue error!!! Payload is ${JSON.stringify(payload)}!!!`), payload, origin: "addActiveChallengeThunk.rejected."});
         } else {
            console.error({errorMessage: "Oops... we have problem trying to upload active cahllenge to Firebase!!!", payload, origin: "addActiveChallengeThunk.rejected."})
         }
      }
   }
})

export const { addNewUpcomingChallenge, updateChallenge, removeUpcomingChallenge, addActiveChallenge, removeActiveChallenge, transferChallenge } = challengesSlice.actions;

export const challengesSliceReducer = challengesSlice.reducer;

export const challengesState = state => state.challengesSliceReducer;

export const allUpcomingChallenges = state => state.challengesSliceReducer.allUpcomingChallenges;

export const completedChallenges = state => state.challengesSliceReducer.completedChallenges;

export const allActiveChallenges = state => state.challengesSliceReducer.allActiveChallenges;